/**
 * usePeople — Issue #51
 *
 * GET /api/v2/people liefert die serverseitig gemergte Contact/Host-Liste
 * (Merge-Schluessel: E-Mail, sonst normalisierter Name — siehe
 * Api::V2::PeopleController / PeopleMergeService im Backend). Ersetzt den
 * client-seitigen, email-only Merge, der frueher direkt in ContactsPage.tsx
 * stand (mergePeople).
 */
import { useApi } from '../../lib/use-api'
import apiClient from '../../lib/api-client'
import type { components } from '@heliumtracker/api-types'

export type PersonDto = components['schemas']['Person']

type PeopleResponse = { data?: PersonDto[] }

export function usePeople() {
  const query = useApi<PeopleResponse>(['people'], () => apiClient.GET('/api/v2/people', {}))

  return {
    people: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => query.refetch(),
  }
}
